import { render, staticRenderFns } from "./kcp-cert.vue?vue&type=template&id=2ec70ff1"
import script from "./kcp-cert.vue?vue&type=script&lang=js"
export * from "./kcp-cert.vue?vue&type=script&lang=js"
import style0 from "./kcp-cert.vue?vue&type=style&index=0&id=2ec70ff1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports